import React, { FC, ReactNode } from 'react';
import { Cell, Grid }           from "styled-css-grid";
import { Icon, IconProps } from 'semantic-ui-react';
import { ClassValue }      from 'classnames/types';
import classNames          from 'classnames';

import { MenuItemArrowIndicator, MenuItemArrowIndicatorProps } from '../components/menus/MenuItemArrowIndicator';

interface Props {
	labelContent?: string | ReactNode,
	withIndicator?: boolean,
	withIcon?: boolean,
	iconProps?: IconProps,
	indicatorProps?: MenuItemArrowIndicatorProps,
	containerClasses?: ClassValue,
}

const defaultProps: Props = {
	labelContent:     'Menu Item',
	withIndicator:    true,
	indicatorProps:   {
		active:   false,
		position: 'right',
	},
	withIcon:         true,
	iconProps:        {
		name:  'cube',
		color: 'teal',
	},
	containerClasses: [
		'padding-sm-right'
	]
}

const MenuItemContainer: FC<Props> = ( props ) => {
	
	return (
		
		<Grid columns={ `auto 1fr auto` } columnGap={ '10px' } className={ classNames( props.containerClasses ) }>
			
			<Cell middle>
				
				{ props.withIcon && (
					<Icon { ...props.iconProps }/>
				) }
			
			</Cell>
			<Cell middle>
				
				{ props.labelContent }
			
			</Cell>
			<Cell middle>
				
				{ props.withIndicator && (
					<MenuItemArrowIndicator { ...props.indicatorProps } />
				) }
			
			</Cell>
		</Grid>
	);
};

MenuItemContainer.defaultProps = defaultProps;

export { MenuItemContainer }
